import type { BusinessContextRequestPolicy } from "./requestBarrier"

export class BusinessContextStaleResponseError extends Error {
  readonly silent = true

  constructor() {
    super("业务上下文已变化，忽略旧请求响应")
    this.name = "BusinessContextStaleResponseError"
  }
}

export class BusinessContextStaleRequestError extends Error {
  readonly code = "ERR_CANCELED"
  readonly silent = true

  constructor() {
    super("业务上下文已变化，取消旧页面请求")
    this.name = "BusinessContextStaleRequestError"
  }
}

export function isBusinessContextStaleRequestError(error: unknown) {
  return error instanceof Error && error.name === "BusinessContextStaleRequestError"
}

export function isBusinessContextCancellation(error: unknown) {
  if (!error || typeof error !== "object") return false
  const name = (error as { name?: unknown }).name
  return name === "BusinessContextStaleRequestError"
    || name === "BusinessContextStaleResponseError"
}

export function preventUnhandledBusinessContextCancellation(
  event: Pick<PromiseRejectionEvent, "reason" | "preventDefault">,
) {
  if (!isBusinessContextCancellation(event.reason)) return false
  event.preventDefault()
  return true
}

export function isStaleAuthFailure(
  authTokenAtDispatch: string | undefined,
  currentToken: string,
  businessContextRevisionAtDispatch?: number,
  currentBusinessContextRevision?: number,
) {
  if (authTokenAtDispatch === undefined) return false
  return authTokenAtDispatch !== currentToken
    || (
      businessContextRevisionAtDispatch !== undefined
      && currentBusinessContextRevision !== undefined
      && businessContextRevisionAtDispatch !== currentBusinessContextRevision
    )
}

export function shouldCancelRequestAfterBusinessContextBarrier(options: {
  authTokenBeforeBarrier: string
  authTokenAfterBarrier: string
  revisionBeforeBarrier: number
  revisionAfterBarrier: number
  requestPolicy: BusinessContextRequestPolicy
}) {
  if (options.requestPolicy === "rebind") return false
  return isStaleAuthFailure(
    options.authTokenBeforeBarrier,
    options.authTokenAfterBarrier,
    options.revisionBeforeBarrier,
    options.revisionAfterBarrier,
  )
}
